"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftAcceptTradeBuilder = void 0;
const enums_1 = require("../enums");
const transactions_1 = require("../transactions");
const nft_exchange_builder_1 = require("./nft-exchange-builder");
class NftAcceptTradeBuilder extends nft_exchange_builder_1.NFTExchangeTransactionBuilder {
    constructor() {
        super();
        this.data.type = enums_1.NFTTransactionTypes.NFTAcceptTrade;
        this.data.fee = transactions_1.NFTAcceptTradeTransaction.staticFee();
        this.data.asset = { nftAcceptTrade: {} };
    }
    NFTAcceptTradeAsset(nftAcceptTrade) {
        if (this.data.asset && this.data.asset.nftAcceptTrade) {
            this.data.asset.nftAcceptTrade = {
                ...nftAcceptTrade,
            };
        }
        return this;
    }
    instance() {
        return this;
    }
}
exports.NftAcceptTradeBuilder = NftAcceptTradeBuilder;
//# sourceMappingURL=nft-accept-trade.js.map